export class UpdateWorkspaceMetricsSettingsInputGcp {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cloudMonitoringEnabled",
            "baseName": "cloudMonitoringEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "cloudMonitoringMetricPrefix",
            "baseName": "cloudMonitoringMetricPrefix",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateWorkspaceMetricsSettingsInputGcp.attributeTypeMap;
    }
    constructor() {
    }
}
